import uuid from 'react-uuid';

const generateOAuthState = (): string => {
  return uuid();
};

const OAUTH_STATE_KEY = 'oauth_state';

const saveOAuthState = (state: string) => {
  sessionStorage.setItem(OAUTH_STATE_KEY, state);
};
const getOAuthState = (): string | null => {
  return sessionStorage.getItem(OAUTH_STATE_KEY);
};
const clearOAuthState = () => {
  sessionStorage.removeItem(OAUTH_STATE_KEY);
};

export { generateOAuthState, saveOAuthState, getOAuthState, clearOAuthState };
